import { DatePipe } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import * as alerts from '../../_functions/alerts';
import { Membro, StatusMembro } from '../../_models/membro';
import {
  MessageRequetModel,
  SmsRequestModel,
} from '../../_models/smsRequestModel';
import { AuthService } from '../../_services/auth.service';
import { FidelidadeService } from '../../_services/fidelidade.service';

@Component({
  selector: 'app-validar-dados',
  templateUrl: './validar-dados.component.html',
  styleUrls: ['./validar-dados.component.scss'],
})
export class ValidarDadosComponent implements OnInit {
  // Formulario
  public membroForm: UntypedFormGroup;
  public readonly ETAPA_METODO_ENVIO: number = 1;
  public readonly ETAPA_ENVIO: number = 2;
  public readonly ETAPA_VALIDAR_CODIGO: number = 3;
  public readonly ETAPA_FINAL: number = 4;
  private readonly METODO_EMAIL: string = 'email';
  private readonly METODO_CELULAR: string = 'telefone';
  public etapaAtual: number = 1;
  public metodoAtual: string = '';
  public exibirDataVazio: boolean = false;

  // Carregamentos
  public carregandoMetodoEnvioCelular: boolean = false;
  public carregandoMetodoEnvioEmail: boolean = false;
  public enviarCodigoOtp: boolean = false;

  // código otp
  otpInputConfig = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '2.5rem',
      height: '3rem',
      'border-radius': '1.5rem',
      'font-family': 'Sagona',
      'font-size': '24px',
    },
  };

  // Membro
  public membro: Membro = new Membro();
  private idade: number = 0;
  public menorQueDataLimite: boolean = false;
  private dadosvalidados: boolean = false;

  // Counter
  public habilitaReenvio: boolean = false;
  public counter: number = 60;

  // Formatação
  formatResumo: boolean = window.innerWidth <= 480;

  constructor(
    private fb: UntypedFormBuilder,
    private fidelidadeService: FidelidadeService,
    private datepipe: DatePipe,
    private authService: AuthService,
    private router: Router
  ) {
    this.registrarForm();
  }

  ngOnInit(): void {
    this.obterMembro();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.formatResumo = window.innerWidth <= 480;
  }

  private registrarForm() {
    this.membroForm = this.fb.group({
      dataNascimento: [''],
      telefone: ['', [Validators.required, Validators.minLength(11)]],
      email: ['', []],
    });
  }

  public voltar() {
    if (this.etapaAtual < this.ETAPA_METODO_ENVIO) return;
    if (this.etapaAtual === this.ETAPA_METODO_ENVIO) {
      this.metodoAtual = '';
    }

    this.etapaAtual--;
  }

  // Obter membro
  private obterMembro() {
    this.fidelidadeService.obterMembro().subscribe(
      (sucesso) => {
        this.processarSucessoObterMembro(sucesso);
      },
      (falha) => {
        this.processarFalhaObterMembro(falha);
      }
    );
  }
  private processarSucessoObterMembro(response: Membro) {
    if (response.telefone) response.telefone = response.telefone.substring(2);

    if (response.tipoStatus == StatusMembro.DADOS_INVALIDOS) {
      this.membro = response;
      return;
    }
    this.membroForm.value.dataNascimento = response.dataNascimento;
    this.membroForm.value.telefone = response.telefone;
    this.membroForm.value.email = response.email;

    this.membro = response;
    this.preencherForm();

    const nascimento: string = this.converterData(this.membro.dataNascimento);
    const ano = Number(nascimento.substring(6, 10));

    this.idade = new Date().getFullYear() - ano;

    if (this.idade > 120) {
      this.menorQueDataLimite = true;
      return { dataInvalida: true };
    }
  }

  private processarFalhaObterMembro(err: any) {
    console.error(err);
  }

  // Ajuste data
  public converterData(data: Date): string {
    return this.datepipe.transform(data, 'dd/MM/yyyy');
  }
  public converterDataPreencher(data: Date, format: string) {
    return this.datepipe.transform(data, format);
  }

  // Preencher form
  private preencherForm() {
    const dataNascimentoMinima = new Date(1753, 0, 1, 0, 0, 0);

    const nascimento: any = this.membro.dataNascimento;
    const ano = Number(nascimento.substring(0, 4));
    const mes = Number(nascimento.substring(5, 7));
    const dia = Number(nascimento.substring(8, 10));

    var dataFinal = `${ano}/${mes}/${dia}`;

    const nascimentoDate: Date = new Date(dataFinal);
    if (dataNascimentoMinima.toISOString() == nascimentoDate.toISOString())
      this.exibirDataVazio == true;

    this.membroForm.patchValue({
      dataNascimento: this.exibirDataVazio
        ? '--/--/--'
        : this.converterDataPreencher(this.membro.dataNascimento, 'ddMMyyyy'),
      telefone: this.membro.telefone,
      email: this.membro.email,
    });
  }

  // Metodo de envio
  public metodoEnvio(metodo: string) {
    this.membro.senha = null;
    this.membro.senhaConfirmacao = null;

    if (metodo === this.METODO_EMAIL) {
      this.carregandoMetodoEnvioEmail = true;
      this.membroForm.get('email').setValue(this.membro.email);
      this.validarEmailOuTelefoneDisponivel(metodo);
      this.metodoAtual = this.METODO_EMAIL;
    }
    if (metodo === this.METODO_CELULAR) {
      this.carregandoMetodoEnvioCelular = true;
      this.membroForm.get('telefone').setValue(this.membro.telefone);
      this.validarEmailOuTelefoneDisponivel(metodo);
      this.metodoAtual = this.METODO_CELULAR;
    }
  }

  // Valida email ou telefone disponivel
  private validarEmailOuTelefoneDisponivel(campoValidacao: string) {
    const membroModel: Membro = this.membro;
    membroModel.id = this.membro.id;
    membroModel.cpf = this.membro.cpf;
    membroModel.telefone = '55' + this.membroForm.value.telefone;
    membroModel.email = this.membroForm.value.email;

    this.fidelidadeService
      .validarEmailOuTelefoneDisponivel(membroModel, campoValidacao)
      .subscribe(
        (sucesso) => {
          this.processarSucessoValidarEmailOuTelefoneDisponivel(
            sucesso,
            campoValidacao
          );
        },
        (falha) => {
          this.processarFalhaValidarEmailOuTelefoneDisponivel(
            falha,
            campoValidacao
          );
        }
      );
  }

  private processarSucessoValidarEmailOuTelefoneDisponivel(
    res: boolean,
    campoValidacao: string
  ) {
    if (res == true) {
      this.carregandoMetodoEnvioCelular = false;
      this.carregandoMetodoEnvioEmail = false;
      this.etapaAtual = this.ETAPA_ENVIO;
    } else {
      console.log('Email ou celular não disponível.');
      this.carregandoMetodoEnvioCelular = false;
      this.carregandoMetodoEnvioEmail = false;
    }
  }

  public enviarCodigo(campoValidacao: string) {
    if (
      this.membroForm.controls['email'].value === '' ||
      this.membroForm.controls['telefone'].value === ''
    ) {
      return;
    }

    this.enviarCodigoOtp = true;

    if (campoValidacao == this.METODO_CELULAR) {
      this.dispararSms();
    } else if (campoValidacao == this.METODO_EMAIL) {
      this.dispararEmail();
    }
  }

  private processarFalhaValidarEmailOuTelefoneDisponivel(
    falha: any,
    campoValidacao: string
  ) {
    this.carregandoMetodoEnvioCelular = false;
    this.carregandoMetodoEnvioEmail = false;
    console.log(falha);
  }

  // Disparar sms
  private dispararSms() {
    this.fidelidadeService
      .enviarSmsValidarCampoComIdMembro(
        this.obterSmsRequestModel(),
        this.membro.id
      )
      .subscribe(
        (sucesso) => {
          this.processarSucessoEnvioSms(sucesso);
        },
        (falha) => {
          this.processarFalhaEnvioSms(falha);
        }
      );
  }

  private obterSmsRequestModel(): SmsRequestModel {
    var smsRequestModel: SmsRequestModel = new SmsRequestModel();

    var messages: MessageRequetModel[] = [
      {
        to: '55' + this.membroForm.value.telefone.toString(),
        body: '',
      },
    ];

    smsRequestModel.messages = messages;

    return smsRequestModel;
  }

  private processarSucessoEnvioSms(response: any) {
    this.enviarCodigoOtp = false;
    this.etapaAtual = this.ETAPA_VALIDAR_CODIGO;
    this.habilitaReenvio = false;
    this.counter = 60;
    // this.ngxOtp.clear();

    setInterval(() => {
      if (this.counter > 0) {
        this.counter--;
        this.habilitaReenvio = false;
      } else {
        this.habilitaReenvio = true;
      }
    }, 1000);
  }

  private processarFalhaEnvioSms(response: any) {
    this.enviarCodigoOtp = false;
    console.log(response);
  }

  // Disparar email
  private dispararEmail() {
    this.fidelidadeService
      .enviarEmailValidarCampoComIdMembro(
        this.membroForm.value.email.toString(),
        this.membro.id
      )
      .subscribe(
        (sucesso) => {
          this.processarSucessoEnvioEmail(sucesso);
        },
        (falha) => {
          this.processarFalhaEnvioEmail(falha);
        }
      );
  }

  private processarSucessoEnvioEmail(response: any) {
    this.enviarCodigoOtp = false;
    this.etapaAtual = this.ETAPA_VALIDAR_CODIGO;
    this.habilitaReenvio = false;
    this.counter = 60;
    // this.ngxOtp.clear();

    setInterval(() => {
      if (this.counter > 0) {
        this.counter--;
        this.habilitaReenvio = false;
      } else {
        this.habilitaReenvio = true;
      }
    }, 1000);
  }

  private processarFalhaEnvioEmail(response: any) {
    this.enviarCodigoOtp = false;
    console.log(response);
  }

  // Validar código
  validarCodigo(otp: any) {
    let pinCode: string = otp;

    if (pinCode?.length < 6) return;

    if (this.metodoAtual == this.METODO_CELULAR) this.validarSms(pinCode);
    else if (this.metodoAtual == this.METODO_EMAIL) this.validarEmail(pinCode);
  }

  private validarSms(pinCode: string) {
    this.fidelidadeService
      .validarPinCodeSmsValidarCampo(this.obterSmsRequestModel(), pinCode)
      .subscribe(
        (sucesso) => {
          if (sucesso.resultado == true) {
            this.fidelidadeService.obterMembro().subscribe(
              (sucesso: Membro) => {
                sucesso.telefoneValidado = true;
                sucesso.telefone = '55' + this.membroForm.value.telefone;
                sucesso.senha = null;

                this.fidelidadeService
                  .atualizarMembroValidaDados(
                    sucesso,
                    sucesso.email ?? sucesso.cpf
                  )
                  .subscribe(
                    (sucesso) => {
                      this.processarSucessoAtualizarMembro(sucesso);
                    },
                    (falha) => {
                      // this.ngxOtp.clear();
                      this.processarFalhaAtualizarMembro(falha);
                    }
                  );
              },
              (falha) => {
                // this.ngxOtp.clear();
                this.processarFalhaObterMembro(falha);
              }
            );
          } else {
            // this.ngxOtp.clear();
            alerts.exibirToast('error', 'Código informado inválido!');
            return;
          }
        },
        (falha) => {}
      );
  }

  private processarSucessoAtualizarMembro(result: any) {
    this.fidelidadeService.obterMembro().subscribe(
      (sucesso) => {
        this.dadosvalidados =
          (sucesso.telefoneValidado ||
            sucesso.emailValidado ||
            (!sucesso.emailValidado && !this.emailEObrigatorio(sucesso))) &&
          this.dataNascimentoValida(sucesso);
        this.authService.LocalStorage.salvarDadosValidados(this.dadosvalidados);
        this.authService.LocalStorage.salvarMembro(sucesso);
        this.processarSucessoObterMembro(sucesso);
        this.etapaAtual = this.ETAPA_FINAL;
      },
      (falha) => {
        this.processarFalhaObterMembro(falha);
      }
    );
  }

  private processarFalhaAtualizarMembro(err: any) {
    console.log(err);
  }

  emailEObrigatorio(membro: any) {
    const nascimento: string = membro.dataNascimento;
    const ano = Number(nascimento.substring(0, 4));
    const mes = Number(nascimento.substring(5, 7));
    const dia = Number(nascimento.substring(8, 10));

    var dataFinal = `${ano}/${mes}/${dia}`;

    const nascimentoDate: Date = new Date(dataFinal);

    let age = this.getAge(nascimentoDate);

    if (age >= 65) return false;
    else return true;
  }

  getAge(birthDate: Date) {
    var today = new Date();
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  dataNascimentoValida(membro: any) {
    const dataNascimentoMinima = new Date(1753, 0, 1, 0, 0, 0);

    const nascimento: string = membro.dataNascimento;
    const ano = Number(nascimento.substring(0, 4));
    const mes = Number(nascimento.substring(5, 7));
    const dia = Number(nascimento.substring(8, 10));

    var dataFinal = `${ano}/${mes}/${dia}`;

    const nascimentoDate: Date = new Date(dataFinal);

    if (dataNascimentoMinima.toISOString() == nascimentoDate.toISOString())
      return false;
    else return true;
  }

  private validarEmail(pinCode: string) {
    this.fidelidadeService
      .validarPinCodeEmailValidarCampo(this.membro, pinCode)
      .subscribe(
        (sucesso) => {
          if (sucesso.resultado == true) {
            this.fidelidadeService.obterMembro().subscribe(
              (sucesso: Membro) => {
                sucesso.emailValidado = true;
                sucesso.email = this.membroForm.value.email;
                sucesso.senha = null;
                sucesso.telefone = '55' + this.membroForm.value.telefone;

                this.fidelidadeService
                  .atualizarMembroValidaDados(
                    sucesso,
                    sucesso.email ?? sucesso.cpf
                  )
                  .subscribe(
                    (sucesso) => {
                      this.processarSucessoAtualizarMembro(sucesso);
                    },
                    (falha) => {
                      // this.ngxOtp.clear();
                      this.processarFalhaAtualizarMembro(falha);
                    }
                  );
              },
              (falha) => {
                // this.ngxOtp.clear();
                this.processarFalhaObterMembro(falha);
              }
            );
          } else {
            // this.ngxOtp.clear();
            alerts.exibirToast('error', 'Código informado inválido!');
            return;
          }
        },
        (falha) => {}
      );
  }

  public reenviarOTP() {
    if (this.metodoAtual == this.METODO_CELULAR) {
      this.dispararSms();
    }
    if (this.metodoAtual == this.METODO_EMAIL) {
      this.dispararEmail();
    }
  }

  // Login com sucesso
  public dadosValidadosSucesso() {
    var linkRedirect =
      this.authService.LocalStorage.obterRedirectLink().replace(/['"]+/g, '');

    if (linkRedirect != '') this.router.navigateByUrl(linkRedirect);
    else this.router.navigate(['/index']);
  }

  // Sair
  public cancelar() {
    this.authService.LocalStorage.desconectar();
    this.router.navigate(['/']);
  }

  // Validar outro campo
  public outroCampo() {
    this.metodoAtual = '';
    this.etapaAtual = this.ETAPA_METODO_ENVIO;
  }
}
